import { HlsLiveResumeHelper } from '../HlsLiveResumeHelper';

export class DualHlsLiveResumeHelper extends HlsLiveResumeHelper {
	protected onLivePause(): void {
		setTimeout(() => {
			const player = this.hlsPlayer as any;

			//The below OR condition is workaround.
			//In case of embed webcast, we started seeing pause event getting triggered
			//when user enters or comes out of full screen mode but video is in play mode.
			//check AV-26536 for info.
			if (!player || player.isDualBuffering || (!player.isPrimaryPlayer && player.isPlaying)) {
				return;
			}

			super.onLivePause();
		}, 50);
	}

	protected onLivePlay(): void {
		if ((this.hlsPlayer as any).isDualBuffering) {
			return;
		}

		super.onLivePlay();
	}
}
